// app/javascript/projects/components/ProjectArchivePage.jsx

import React from 'react';
import FullPageMessage from 'projects/components/FullPageMessage';
import { useProjectModal } from '../contexts/ProjectModalContext';

function ProjectArchivePage(props) {
  const { showProjectModal } = useProjectModal();
  
  return (
    <FullPageMessage
      header='Project has been archived'
      body={!!props.isProjectOwner ? 'Unarchive the project to view it.' : 'The project must be unarchived by the owner to be viewed.'}
      onClick={showProjectModal}
      buttonText='Go back to projects'
      subButtonText='See archived projects'
      subButtonTo={props.isProjectOwner ? '/users/archived' : null}
    />
  );
}

export default ProjectArchivePage;